module.exports = __webpack_public_path__ + "images/fograi-260w.png";